import { Search, Filter } from 'lucide-react'
import type { DateRange } from 'react-day-picker'
import { Input } from '@/components/ui/input'
import { DateRangeFilter } from '@/components/common/DateRangeFilter'

interface DeletedPlansFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  deletedRange: DateRange | undefined
  onDeletedRangeChange: (value: DateRange | undefined) => void
}

export function DeletedPlansFilters({
  searchInput,
  onSearchChange,
  deletedRange,
  onDeletedRangeChange,
}: DeletedPlansFiltersProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-[352px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search deleted plans..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      {/* Filter Icon */}
      <Filter className="h-6 w-6 text-muted-foreground" />

      {/* Deleted date range */}
      <DateRangeFilter
        value={deletedRange}
        onValueChange={onDeletedRangeChange}
        placeholder="Deleted date"
      />
    </div>
  )
}
